import React from 'react';
import { string } from 'prop-types';

export default function CartEmptyStateSvg({ className }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="100" height="101" viewBox="0 0 100 101" className={className}>
      <g fill="none">
        <path fill="#FFF" d="M0 1h100v100H0z" />
        <g>
          <path
            fill="#B0DFFB"
            d="M80.397 99.992H19.014a8.708 8.708 0 0 1-6.439-2.434 8.425 8.425 0 0 1-2.571-6.299l5.817-60.362c.596-4.382 4.507-7.581 8.993-7.356h49.783c4.474-.207 8.364 2.988 8.96 7.356l5.851 60.362a8.425 8.425 0 0 1-2.571 6.3 8.708 8.708 0 0 1-6.44 2.433z"
          />
          <path
            fill="#D9EFFC"
            d="M65.341 38.235c-1.923 0-3.482-1.488-3.482-3.325V14.13c0-4.156-4.283-7.48-9.541-7.48h-5.224c-5.223 0-9.54 3.324-9.54 7.48v20.78c0 1.837-1.56 3.325-3.483 3.325s-3.482-1.488-3.482-3.325V14.13C30.519 6.334 37.919 0 47.025 0h5.223c9.176 0 16.576 6.334 16.576 14.13v20.78c0 1.837-1.56 3.325-3.483 3.325z"
          />
          <path
            fill="#D8EFFD"
            d="M10.004 91.177a8.546 8.546 0 0 0 2.571 6.358 8.662 8.662 0 0 0 6.44 2.457h61.382a8.662 8.662 0 0 0 6.44-2.457 8.546 8.546 0 0 0 2.571-6.358l-1.156-11.765H11.16l-1.156 11.765z"
          />
        </g>
      </g>
    </svg>
  );
}

CartEmptyStateSvg.propTypes = {
  className: string,
};
